module.exports = __webpack_public_path__ + "static/media/gitlab_logo.844eae46.png";